import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  List, ListItemButton, ListItemText,
} from '@mui/material'
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined'
import { selectPortfolioFolderTree } from 'ducks/portfolioDocuments/selectors'
import { bulkMovePortfolioFilesRoutine } from 'ducks/portfolioDocuments/actions'

const flatten = (nodes, depth = 0, acc = []) => {
  (nodes || []).forEach((n) => {
    acc.push({ id: n.id, name: n.name, depth })
    flatten(n.childFolders, depth + 1, acc)
  })
  return acc
}

export default function BulkMoveDocumentsModal({ portfolioId, fileIds, fromFolderId, onMoved, onClose }) {
  const dispatch = useDispatch()
  const tree = useSelector(selectPortfolioFolderTree)
  const folders = flatten(tree).filter((f) => f.id !== fromFolderId)

  const move = (target) => {
    dispatch(bulkMovePortfolioFilesRoutine.trigger({
      portfolioId,
      fileIds,
      portfolioFolderId: target.id,
      fromFolderId,
      folderName: target.name,
    }))
    onMoved && onMoved()
    onClose()
  }

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Move {fileIds.length} document{fileIds.length === 1 ? '' : 's'}</DialogTitle>
      <DialogContent dividers>
        <p style={{ marginTop: 0, color: '#666', fontSize: 14 }}>Choose a folder to move the selected documents to.</p>
        {folders.length === 0 ? (
          <p style={{ color: '#888' }}>There are no other folders to move them to.</p>
        ) : (
          <List dense sx={{ maxHeight: 320, overflow: 'auto' }}>
            {folders.map((f) => (
              <ListItemButton key={f.id} onClick={() => move(f)} sx={{ pl: 1 + f.depth * 2 }}>
                <FolderOutlinedIcon style={{ fontSize: 18, color: '#c9a99b', marginRight: 10 }} />
                <ListItemText primary={f.name} />
              </ListItemButton>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  )
}
